import 'react-toastify/dist/ReactToastify.css';

import { CssBaseline, ThemeProvider } from '@mui/material';
import { ConfirmProvider } from 'material-ui-confirm';
import { memo } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { defaultConfirmProps, env, Locales } from './config/constants';
import { DateFnsProvider } from './contexts/DateFnsProvider';
import { IntlContextProvider, IntlState } from './contexts/IntlContext';
import { OidcContextProvider } from './contexts/OidcContext/OidcContextProvider';
import { OidcWrapper } from './contexts/OidcContext/OidcWrapper';
import { UiContextProvider } from './contexts/UiContext';
import { theme } from './theme';
import en from './translations/en.json';
import fr from './translations/fr.json';
import { App } from './views/App';

const messagesMap: Record<Locales, Record<string, any>> = {
    [Locales.fr]: fr,
    [Locales.en]: en,
};
const intlConfig: Partial<IntlState> = {
    translations: messagesMap,
};

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 0,
            cacheTime: 5 * 60 * 1000,
            refetchOnWindowFocus: false,
            refetchInterval: false,
            refetchOnMount: false,
        },
    },
});

export const Root = memo(function Root() {
    return (
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <OidcContextProvider>
                    <OidcWrapper>
                        <IntlContextProvider config={intlConfig} textComponent="span">
                            <DateFnsProvider>
                                <ThemeProvider theme={theme}>
                                    <UiContextProvider>
                                        <ConfirmProvider defaultOptions={defaultConfirmProps}>
                                            <CssBaseline />
                                            <App />
                                            <ToastContainer style={{ width: 360, margin: 10 }} />
                                        </ConfirmProvider>
                                    </UiContextProvider>
                                </ThemeProvider>
                            </DateFnsProvider>
                        </IntlContextProvider>
                    </OidcWrapper>
                </OidcContextProvider>
                {env === 'dev' && <ReactQueryDevtools initialIsOpen={false} />}
            </QueryClientProvider>
        </BrowserRouter>
    );
});
